// Miudezas de texto e de estado compartilhadas pelas telas de workspace (Cartões, Contas, Categorias).

import { matchesAmountQuery, parseAmountQuery } from '@/lib/searchText';

/** Busca sem acento e sem caixa: "Alimentação" casa com "alimentacao". */
export const normalize = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLocaleLowerCase('pt-BR');

/**
 * O termo da busca lido também como valor, pelo critério do app (ADR 0186): reais inteiros e
 * centavos pelo começo, então "150" acha 150,00 a 150,99 e não 1.150, e "89,9" acha 89,90 a
 * 89,99. `null` quando o termo não parece número; aí a busca é só pelo texto.
 */
export function amountSearch(query: string): ((amount: number) => boolean) | null {
  const parsed = parseAmountQuery(query);
  return parsed ? (amount) => matchesAmountQuery(amount, parsed) : null;
}

export const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

/** "Setembro de 2026" → "setembro de 2026", pra entrar no meio da frase. */
export const lower1 = (s: string) => s.charAt(0).toLowerCase() + s.slice(1);

/** Liga/desliga um id num Set imutável (filtros de múltipla escolha). */
export function toggle(set: Set<string>, id: string): Set<string> {
  const next = new Set(set);
  if (next.has(id)) next.delete(id);
  else next.add(id);
  return next;
}
